import React from 'react'
import { BtnV2 } from '@manychat/manyui'
import { BtnV2Props } from '@manychat/manyui/src/components/BtnV2'

import { useKeyDown } from 'common/core/coreHooks'

interface BtnV2WithKeyCodeProps extends Omit<BtnV2Props, 'className' | 'onClick' | 'onlyIcon'> {
  onClick: () => void
  keyCode?: string
  ariaLabel?: string
}

export const BtnV2WithKeyCode = ({
  keyCode,
  onClick,
  children,
  ...props
}: BtnV2WithKeyCodeProps) => {
  useKeyDown({
    key: keyCode,
    onPress: onClick,
  })

  return (
    <BtnV2 as="button" onClick={() => onClick()} className="p-x-sm" variant="primary" {...props}>
      {children}
    </BtnV2>
  )
}
